module.exports = __webpack_public_path__ + "img/pain.c4909b43.jpg";